export default {
  siteResolution: { width: null, height: null },
  selectedPage: null,
  coefficient: 1,
  selectedComponent: null,
  modifiedPageIds: new Set(),
  deletedPageIds: [],
  localNewPages: [],
  siteEditorReturnState: null,
  employeeSearchPhrase: "",
  searchPhrase: "",
  employeeList: [],
  allEmployees: [],
  employeeObj: {},
  finishRegisterSettings: {},
  defaultEmployeeList: [],
  visitorObj: {},
  localPageSize: {},
  dropinObject: {},
  validate: {},
  companyQueueLines: [],
  queueVisitors: {},
  jobDepartments: [],
  jobDepartment: {},
  infoSearchCategories: [],
  infoSearchCategory: {},
  infoSearchSubCategory: {},
  departmentUsers: [],
  elementsShifted: null,
  graveyard: {},
  graveyardGravar: {},
  patient: {},
  searchPage: {},
  buttonState: {},
  actionResult: {},
  agreementSettings: {
    shouldAcceptAgreement: false,
    acceptedAgreement: false,
    showAcceptAgreementPopup: false,
    acceptedHook: {}
  },
  shouldResetUserAppliedState: false,
  statisticsVisitors: {},
  statisticsQueue: {},
  statisticsVisHistory: {},
  multiQueue: null,
  progress: null
};
